function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H32V32H0z",
  transform: "translate(-660 -850) translate(0 832) translate(660 18)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.867 15.893c-2.24 0-4.374-.96-5.867-2.613C.507 11.627-.213 9.387.053 7.147.453 3.547 3.36.64 6.96.24 9.2 0 11.44.693 13.093 2.187c1.68 1.493 2.64 3.626 2.64 5.866 0 1.2-.293 2.427-.826 3.494l.773 2.32c.107.346.027.72-.213.96s-.614.346-.96.266l-2.16-.586c-1.307.906-2.854 1.386-4.48 1.386zm.026-14.64c-.266 0-.533.027-.8.054-3.12.346-5.626 2.853-5.973 5.973-.213 1.947.373 3.84 1.68 5.307 1.28 1.44 3.147 2.266 5.067 2.266 1.413 0 2.746-.426 3.893-1.226.24-.16.533-.214.827-.134l2 .56-.72-2.213c-.08-.24-.054-.507.053-.747.48-.933.72-2 .72-3.066 0-1.92-.827-3.787-2.267-5.067-1.253-1.12-2.826-1.707-4.48-1.707z",
  transform: "translate(-660 -850) translate(0 832) translate(660 18) translate(8 8)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.8 1.12H.747C.453 1.12.213.88.213.587c0-.294.24-.534.534-.534H4.8c.293 0 .533.24.533.534 0 .293-.24.533-.533.533zM8 3.173H.747c-.294 0-.534-.24-.534-.533 0-.293.24-.533.534-.533H8c.293 0 .533.24.533.533 0 .293-.24.533-.533.533zM8 5.227H.747c-.294 0-.534-.24-.534-.534 0-.293.24-.533.534-.533H8c.293 0 .533.24.533.533 0 .294-.24.534-.533.534z",
  transform: "translate(-660 -850) translate(0 832) translate(660 18) translate(8 8) translate(3.2 5.333)"
})))))));

var SvgExplanation = function SvgExplanation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExplanation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/explanation.25231406.svg";
export { ForwardRef as ReactComponent };